import React, { useEffect } from "react";

export const CertSeal = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://siteseal.certerassl.com/validate/dynamic/sealvalidation/Xc0ysEXLgqQ=/0";
    // script.async = true;
    document.body.appendChild(script);

    // Cleanup the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      {/* Add any additional content here */}
      <div id="cert-seal-container" />
    </div>
  );
};
